import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MomentPipe } from './dateFormatter';
import { PhoneFormatterPipe } from './phoneFormatter';
import { SearchTextPipe } from './searchText';
import { HighLightTextPipe } from './highlightText';
import { ShowActivePipe } from './showActive';
import { FormsModule } from '@angular/forms';
import { TimeRangePipe } from './timeRange.pipe';
import { FuncPipe } from './func.pipe';

const pipes = [MomentPipe, PhoneFormatterPipe, SearchTextPipe, HighLightTextPipe, ShowActivePipe, TimeRangePipe, FuncPipe];

@NgModule({
  declarations: pipes,
  imports: [CommonModule, FormsModule],
  exports: pipes,
})
export class PipesModule {}
